







































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IWallet } from "@/interfaces";
import WalletVoters from "@/components/wallet/Voters.vue";
import { QrModal } from "@/components/modals";

@Component({
  components: {
    WalletVoters,
    QrModal,
  },
  computed: {
    ...mapGetters("network", ["isListed", "knownWallets", "token"]),
    ...mapGetters("currency", { currencyName: "name" }),
  },
})
export default class WalletDetails extends Vue {
  @Prop({ required: true }) public wallet: IWallet;

  private view = "public";
  private showModal = false;
  private knownWallets: { [key: string]: string };
  private isListed: boolean;
  private token: string;
  private currencyName: string;

  get name() {
    return this.knownWallets[this.wallet.address];
  }

  get isDelegate() {
    return this.wallet.isDelegate;
  }

  get votedDelegate() {
    return this.$store.getters["delegates/byPublicKey"](this.wallet.vote) || {};
  }

  get isVoting() {
    return !!this.wallet.vote;
  }

  get hasLockedBalance() {
    return !!this.wallet.lockedBalance;
  }

  get showBalanceTooltip() {
    return this.isListed && this.token !== this.currencyName;
  }

  private setView(view: string) {
    this.view = view;
  }

  public toggleModal() {
    this.showModal = !this.showModal;
  }
}
